import { useFormikContext } from "formik";
import { toLowerCase } from "../../../../../utils/helpers/stringHelper";
import { FIELD_NAMES } from "../../../../../constants/commonConstants";

export const useRepaymentFrequency = () => {
  const { values } = useFormikContext();
  return toLowerCase(values[FIELD_NAMES.REPAYMENT_FREQUENCY]) || "weekly";
};